import React, { useEffect, useCallback, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import { B2C_STATION_CHARGING_HISTORY, DOWNLOAD_B2C_STATION_CHARGING_HISTORY } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
import moment from 'moment';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { roundOfDigit } from 'components/common/utils';
//import { millisecondsToHourMinute, roundOfDigit } from 'components/common/utils';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { IoSearchOutline } from 'react-icons/io5';
import { BiSort } from 'react-icons/bi';
import fileDownload from 'js-file-download';
import { FETCH_COUNTRY, FETCH_STATE, GET_CITY_BY_STATE } from 'actions/address';
import { FETCH_CPO } from 'actions/partnerManagement';
import { GET_STATION_BY_CITY } from 'actions/chargingStation';
import { MdClear } from 'react-icons/md';
import { Form, Formik } from 'formik';
import Select from 'components/inputs/Select';
import OffCanvas from 'components/inputs/OffCanvas';
import ReactPagination from 'components/general/ReactPagination';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaFilter } from 'react-icons/fa';
import Footer from 'components/general/Footer';

const ChragingHistoryReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [searchText, setSearchText] = useState('');
  const [cityLimit, setCityLimit] = useState(false);
  // const [allB2cStationChargingHistoryData, setAllB2cStationChargingHistoryData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [startDate, setStartDate] = useState(moment(new Date()).startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});
  const [changeState, setChangeState] = useState(false);
  const [changeCity, setChangeCity] = useState(false);
  const [changeStation, setChangeStation] = useState(false);
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [isOcpiPartyId, setIsOcpiPartyId] = useState('false');
  const page = useSelector((state) => state.b2cStationChargingHistory.page);
  const totalData = useSelector((state) => state.b2cStationChargingHistory.total);
  const limit = useSelector((state) => state.b2cStationChargingHistory.limit);
  const totalPages = useSelector((state) => state.b2cStationChargingHistory.totalPages);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const currentUserName = _.get(profileData, 'name', '');

  const chargingHistoryReportList = useSelector((state) => state.b2cStationChargingHistory.b2cStationChargingHistory);
  const isLoader = useSelector((state) => state.b2cStationChargingHistory.isLoading);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);

  // console.log(chargingHistoryReportList);

  const b2cStationChargingHistory = useCallback(
    (value) => {
      if (searchText) {
        const b2cStationChargingHistoryData = {
          ...value,
          type: 'Public',
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          status: 'completed',
          search: searchText,
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: b2cStationChargingHistoryData,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else if (!_.isEmpty(userProfileStations)) {
        const data = {
          ...value,
          type: 'Public',
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          charging_station: userProfileStations,
          status: 'completed',
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else {
        const data = {
          ...value,
          type: 'Public',
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          status: 'completed',
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      }
    },
    [startDate, endDate, searchText]
  );

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else if (!_.isEmpty(advanceFilterData)) {
      if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = {
          ...advanceFilterData,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          state: '',
          city: '',
        };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '', state: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All') {
        const filterData = { ...advanceFilterData, state: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      } else {
        const data = {
          ...advanceFilterData,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        b2cStationChargingHistory(data);
      }
    } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const filterDateData = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        charging_station: userProfileStations,
      };
      b2cStationChargingHistory(filterDateData);
    } else {
      const filterDateData = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
      };
      b2cStationChargingHistory(filterDateData);
    }
  }, [startDate, endDate, sortByItem, advanceFilterData, searchText]);

  // useEffect(() => {
  //   setAllB2cStationChargingHistoryData(
  //     _.filter(
  //       chargingHistoryReportList,
  //       (item) =>
  //         startsWith(_.get(item, 'charger.charging_station.name'), searchText) ||
  //         startsWith(_.get(item, 'transaction_id'), searchText) ||
  //         startsWith(roundOfDigit(_.get(item, 'meterstop') - _.get(item, 'meterstart'), 3).toString(), searchText) ||
  //         startsWith(millisecondsToHourMinute(_.get(item, 'time_taken')).toString(), searchText) ||
  //         startsWith(_.get(item, 'idTag').toString(), searchText) ||
  //         startsWith(_.get(item, 'stop_reason'), searchText) ||
  //         startsWith(_.get(item, 'charger.charger_id'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.name'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.vin_num'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.make'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.model'), searchText)
  //     )
  //   );
  // }, [searchText, chargingHistoryReportList]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  const handleSearch = () => {
    b2cStationChargingHistory({});
  };

  useEffect(() => {
    if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const data = {
        charging_station: userProfileStations,
      };
      b2cStationChargingHistory(data);
    } else {
      b2cStationChargingHistory();
    }
  }, []);

  const getSortByItem = useCallback(
    (name, order, page, filterDateData) => {
      const sortedOrder = order || 'asc';
      if (page && startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        endDate && b2cStationChargingHistory(data);
      } else if (page) {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        b2cStationChargingHistory(data);
      } else if (filterDateData) {
        const data = {
          ...filterDateData,
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        endDate && b2cStationChargingHistory(data);
      } else {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        b2cStationChargingHistory(data);
      }
    },
    [startDate, endDate]
  );

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (!_.isEmpty(advanceFilterData)) {
        if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
          const filterData = {
            ...advanceFilterData,
            charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
            state: '',
            city: '',
          };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
          const filterData = { ...advanceFilterData, city: '', state: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All') {
          const filterData = { ...advanceFilterData, state: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.city === 'All') {
          const filterData = { ...advanceFilterData, city: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        } else {
          const data = {
            ...advanceFilterData,
            page: page.selected + 1,
            from: moment(startDate).utc(),
            to: moment(endDate).utc(),
          };
          b2cStationChargingHistory(data);
        }
      } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
        const filterDateData = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          charging_station: userProfileStations,
          page: page.selected + 1,
        };
        b2cStationChargingHistory(filterDateData);
      } else if (startDate && endDate && searchText) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          search: searchText,
          page: page.selected + 1,
        };
        b2cStationChargingHistory(data);
      } else if (startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          page: page.selected + 1,
        };
        b2cStationChargingHistory(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        b2cStationChargingHistory(data);
      }
    },
    [sortByItem, startDate, endDate, advanceFilterData, searchText]
  );

  // Download Excel Functionality

  const downloadB2CStationChargingHistory = useCallback(() => {
    if (!_.isEmpty(advanceFilterData)) {
      if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = {
          ...advanceFilterData,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          state: '',
          city: '',
        };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '', state: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All') {
        const filterData = { ...advanceFilterData, state: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      } else {
        const data = {
          ...advanceFilterData,
          excel: true,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          report: 'charginghistory',
          type: 'Public',
          status: 'completed',
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Charging History Report'}.xlsx`);
              }
            }
          },
        });
      }
    } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const data = {
        excel: true,
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        report: 'charginghistory',
        type: 'Public',
        status: 'completed',
        charging_station: userProfileStations,
      };
      dispatch({
        type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `${'Charging History Report'}.xlsx`);
            }
          }
        },
      });
    } else {
      const data = {
        excel: true,
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        report: 'charginghistory',
        type: 'Public',
        status: 'completed',
      };
      dispatch({
        type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `${'Charging History Report'}.xlsx`);
            }
          }
        },
      });
    }
  }, [startDate, endDate, advanceFilterData]);

  const downloadFile = () => {
    downloadB2CStationChargingHistory();
  };

  // const onMeterValuesDownloadHandler = (item) => {
  //   dispatch({
  //     type: DOWNLOAD_METER_VALUES,
  //     payload: { id: item.id },
  //     cb: (res) => {
  //       if (res) {
  //         if (_.get(res, 'status') === 200) {
  //           fileDownload(res.data, `${'Charging History Report'}.xlsx`);
  //         }
  //       }
  //     },
  //   });
  // };

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

  const search = (
    <SearchBox
      preIcon={<BsSearch />}
      value={searchText}
      onChange={searchHandler}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          handleSearch();
        }
      }}
    />
  );
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;
  const allCountries = useSelector((state) => state.country.countries);
  const ocpidata = useSelector((state) => state.partnerManagement.partnerDetails);
  const ocpiPage = useSelector((state) => state.partnerManagement.page);
  const ocpiTotalPages = useSelector((state) => state.partnerManagement.totalPages);
  const allState = useSelector((state) => state.state.states);
  const totalStateData = useSelector((state) => state.state.total);
  const allCityByState = useSelector((state) => state.cityByState.cityByStates);
  const totalCityData = useSelector((state) => state.cityByState.total);
  const allStationByCity = useSelector((state) => state.stationByCity.stationByCities);
  const countryPage = useSelector((state) => state.country.page);
  const statePage = useSelector((state) => state.state.page);
  const cityByStatePage = useSelector((state) => state.cityByState.page);
  const countryTotalPage = useSelector((state) => state.country.totalPages);
  const stateTotalPage = useSelector((state) => state.state.totalPages);
  const cityByStateTotalPage = useSelector((state) => state.cityByState.totalPages);
  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);
  const stationList =
    userProfileStations && userProfileStations.length > 0
      ? allStationByCity.filter((x) => userProfileStations.indexOf(x.id) !== -1)
      : allStationByCity;

  const initialValues = !_.isEmpty(advanceFilterData)
    ? { ...advanceFilterData }
    : { country: '', state: '', city: '', charging_station: '', ocpiCredential: '' };

  const getAllCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_COUNTRY.REQUEST, payload: data });
  }, []);

  const getStateByCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getCityByStateName = useCallback((data = {}) => {
    dispatch({ type: GET_CITY_BY_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      access_type: 'Public',
    };
    dispatch({ type: GET_STATION_BY_CITY.REQUEST, payload: stationData });
  }, []);

  const getOcpidata = useCallback(
    (data) =>
      dispatch({
        type: FETCH_CPO.REQUEST,
        payload: data,
      }),
    []
  );

  useEffect(() => {
    if (showAdvanceFilterPopup) {
      getStateByCountry({ country_name: country, limit: totalStateData });
    }
    if (cityLimit) {
      getCityByStateName({ state_names: state, limit: totalCityData });
    }
  }, [country, state, totalStateData, totalCityData, cityLimit]);

  useEffect(() => {
    getAllCountry();
    getOcpidata({ limit: 999 });
  }, []);

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.chargingHistoryReport')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="data-report--main">
              <Card>
                <div className="data-report__inner">
                  <div className="data-report__box">
                    <Row className="data-report__row">
                      <Col
                        xl={`${showSearchBar ? 'auto' : 'atuo'}`}
                        md={`${showSearchBar ? 'auto' : 'auto'}`}
                        className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                      >
                        {showSearchBar ? search : searchIcon}
                      </Col>
                      <Col xl={`${showSearchBar ? 'auto' : 'auto'}`} md={`${showSearchBar ? 'auto' : 'auto'}`}>
                        <div className="data-report-date_picker">
                          <DateTimePicker
                            onChangeOfStartDate={(item) => setStartDate(item)}
                            onChangeOfEndDate={(item) => setEndDate(item)}
                            initialValueOfStartDate={moment(new Date()).startOf('day')}
                            initialValueOfEndDate={moment(new Date()).endOf('day')}
                          />
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-box" onClick={dateFilter}>
                          <Button className="report-search-button">{t('button.search')}</Button>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-excel-block">
                          <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                            <Button className="report-search-button">
                              <FaFilter className="hide-lap" />
                              <span>{t('button.advancedFilter')}</span>
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
                        {isLoading ? (
                          <div className="loader--block">
                            <Spinner as="span" animation="border" size="sm" role="status" />
                          </div>
                        ) : (
                          <div className="report-excel-icon">
                            <BsDownload title="Download" size={28} color={'#3c7cdd'} />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="data-report__table">
                    <div className="table-responsive">
                      <table className="record-list-table" id="table-to-xls">
                        <thead>
                          <tr>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.srNo')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Country</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>State</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>City</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>OCPP Id</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.stationName')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.chargerID')}</span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.partyId')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Connector Type</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.transactionId')}</span>
                                <span className="ico" onClick={() => handleSorting('transaction_id', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.chargingDateTime')}</span>
                                <span className="ico" onClick={() => handleSorting('schedule_datetime', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Meter Start Reading(Wh)</span>
                              <span className="ico" onClick={() => handleSorting('meterstart', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>Meter Stop Reading(Wh)</span>
                              <span className="ico" onClick={() => handleSorting('meterstop', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.sessionUnitConsumption')}</span>
                                <span className="ico" onClick={() => handleSorting('energy_consumed', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Session Start Date Time(hh:mm)</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>Session Stop Date Time(hh:mm)</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.sessionDuration')}</span>
                                <span className="ico" onClick={() => handleSorting('time_taken', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>StartSoC</span>
                              <span className="ico" onClick={() => handleSorting('StartSoc', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>StopSoC</span>
                              <span className="ico" onClick={() => handleSorting('StopSoc', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.reasontoStop')}</span>
                                <span className="ico" onClick={() => handleSorting('stop_reason', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>idTag/OTP</span>
                              <span className="ico" onClick={() => handleSorting('idTag', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>Mobile No.</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>VIN/Registration No.</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>EV Make</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>EV Model</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargingHistoryReport.make')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Download Meter Values</span>
                            </div>
                          </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td colSpan={9} className="border-0">
                                <div className="loader--block">
                                  <Skeleton height={15} width={100} />
                                </div>
                              </td>
                            </tr>
                          ) : _.isEmpty(chargingHistoryReportList) ? (
                            <tr>
                              <td colSpan={10} className="border-0">
                                <div className="empty-data-block">{t('addChargingHistoryReport.noHistoryFound')}</div>
                              </td>
                            </tr>
                          ) : (
                            !(isLoader || _.isUndefined(isLoader)) &&
                            _.map(chargingHistoryReportList, (item, index) => {
                              const connectorData = _.find(_.get(item, 'charger.plugs', []), { connector_id: item.connectorId });
                              const unitConsumed = isNaN(_.get(item, 'meterstop') - _.get(item, 'meterstart'))
                                ? ''
                                : roundOfDigit((_.get(item, 'meterstop') - _.get(item, 'meterstart')) / 1000, 3);
                              const serial_num = limit * (page - 1) + index;
                              function calculateTimeDifference(start, end) {
                                const startTime = moment(start);
                                const stopTime = moment(end);

                                const timeDiffInMS = stopTime - startTime;

                                const seconds = moment.duration(timeDiffInMS).seconds();
                                const minutes = moment.duration(timeDiffInMS).minutes();
                                const hours = Math.trunc(moment.duration(timeDiffInMS).asHours());

                                if (Math.sign(timeDiffInMS) === -1) {
                                  return `-${Math.abs(hours)}:${Math.abs(minutes)}:${Math.abs(seconds)}`;
                                } else {
                                  return `${Math.abs(hours)}:${Math.abs(minutes)}:${Math.abs(seconds)}`;
                                }
                              }
                              return (
                                <tr key={`b2c-station-charging-history-${serial_num}`}>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : serial_num + 1}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'charger.charging_station.name', '')}</td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <>
                                        {_.get(item, 'charger.charger_id', '')} ({_.get(connectorData, 'name', '0')})
                                      </>
                                    )}
                                  </td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'ocpiCredential.partyId', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'transaction_id', '')}</td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : item.schedule_datetime ? (
                                      moment(item.schedule_datetime).format('DD/MM/YYYY H:mm:ss')
                                    ) : (
                                      ''
                                    )}
                                  </td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : unitConsumed}</td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <>{calculateTimeDifference(item.booking_start, item.booking_stop)}</>
                                    )}
                                  </td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'stop_reason', '-')}</td>
                                  {/* <td>{_.get(item, 'idTag', '')}</td> */}
                                  {/* <td>{_.get(item, 'customer_user_booked.phone', '-')}</td> */}
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <>
                                        {_.get(item, 'vehicle.make', '')} ({_.get(item, 'vehicle.model', '')})
                                      </>
                                    )}
                                  </td>
                                  {/* <td onClick={() => onMeterValuesDownloadHandler(item)}>
                                  <Button className="report-download-button">Download Excel</Button>
                                </td> */}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(chargingHistoryReportList) && (
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>

      {/* Report Advance Filter Functionality */}

      {showAdvanceFilterPopup && (
        <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
          <Formik
            enableReinitialize={!_.isEmpty(advanceFilterData)}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              !values.country && delete values['country'];
              !values.state && delete values['state'];
              !values.city && delete values['city'];
              !values.charging_station && delete values['charging_station'];
              !values.is_ocpi_based_booking && delete values['is_ocpi_based_booking'];
              !values.partyId && delete values['partyId'];

              if (values.charging_station === 'All' && values.state === 'All' && values.city === 'All') {
                const b2cStationChargingHistoryData = {
                  ...values,
                  state: '',
                  city: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All' && values.charging_station === 'All') {
                const b2cStationChargingHistoryData = {
                  ...values,
                  state: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.city === 'All' && values.charging_station === 'All') {
                const b2cStationChargingHistoryData = {
                  ...values,
                  city: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All' && values.city === 'All') {
                const b2cStationChargingHistoryData = { ...values, state: '', city: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.city === 'All') {
                const b2cStationChargingHistoryData = { ...values, city: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All') {
                const b2cStationChargingHistoryData = { ...values, state: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.charging_station === 'All') {
                const b2cStationChargingHistoryData = { ...values, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.is_ocpi_based_booking === 'true') {
                const b2cStationChargingHistoryData = { ...values, is_ocpi_based_booking: 'true' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.is_ocpi_based_booking === 'false') {
                const b2cStationChargingHistoryData = { ...values, is_ocpi_based_booking: 'false', partyId: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else {
                b2cStationChargingHistory(values);
              }
              handleAdvanceFilterData(values);
              setSubmitting(false);
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <Select
                    label={t('filters.country')}
                    options={_.map(allCountries, (item) => {
                      return { label: item.name, value: item.name };
                    })}
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectCountry')}
                    name="country"
                    value={values.country}
                    onMenuScrollDown={true}
                    getDataOnScrollDown={getAllCountry}
                    page={countryPage}
                    totalPage={countryTotalPage}
                    onChange={(val) => {
                      getStateByCountry({ country_name: val, limit: 999 });
                      setCountry(val);
                      setFieldValue(`country`, val);
                      setFieldValue(`state`, '');
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.state')}
                    options={
                      !changeState
                        ? values.country &&
                        !_.isEmpty(allState) && [
                          { label: 'All', value: 'All' },
                          ..._.map(allState, (state) => {
                            return { label: state.name, value: state.name };
                          }),
                        ]
                        : values.country && !_.isEmpty(allState) && [{ label: 'All', value: 'All' }]
                    }
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectState')}
                    isMulti
                    name="state"
                    value={values.state}
                    onMenuScrollDown={true}
                    page={statePage}
                    totalPage={stateTotalPage}
                    onChange={(val) => {
                      if (_.includes(val, 'All')) {
                        getCityByStateName({ state_names: '' });
                        setChangeState(true);
                        setFieldValue(`state`, 'All');
                      } else if (_.isEmpty(val)) {
                        setChangeState(false);
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`state`, '');
                      } else {
                        getCityByStateName({ state_names: val });
                        setState(val);
                        setCityLimit(true);
                        setChangeState(false);
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`state`, val);
                      }
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.city')}
                    options={
                      !changeCity
                        ? !_.isEmpty(values.state) &&
                        !_.isEmpty(allCityByState) && [
                          { label: 'All', value: 'All' },
                          ..._.map(allCityByState, (state) => {
                            return { label: state.name, value: state.name };
                          }),
                        ]
                        : !_.isEmpty(values.state) && values.country && !_.isEmpty(allCityByState) && [{ label: 'All', value: 'All' }]
                    }
                    placeholder={t('placeHolder.selectCity')}
                    name="city"
                    isMulti
                    value={values.city}
                    onMenuScrollDown={true}
                    page={cityByStatePage}
                    totalPage={cityByStateTotalPage}
                    onChange={(val) => {
                      if (_.includes(val, 'All')) {
                        getAllStation({ city_array: '' });
                        setChangeCity(true);
                        setFieldValue(`city`, 'All');
                      } else if (_.isEmpty(val)) {
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`city`, '');
                      } else {
                        getAllStation({ city_array: val });
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue('city', val);
                      }
                      setFieldValue(`charging_station`, '');
                    }}
                  />
                  <div className="canvas-selection__block">
                    <Select
                      label={t('filters.station')}
                      options={
                        !changeStation
                          ? (!_.isEmpty(_.get(values, 'city')) && !_.isEmpty(stationList) && _.get(values, 'state') === 'All') ||
                            _.get(stationList, 'city') === _.get(values, 'city')
                            ? [
                              ..._.map(stationList, (station) => {
                                return { label: station?.name, value: station?.id };
                              }),
                            ]
                            : [
                              ..._.map(
                                stationList?.filter((o) => o.state === values.state[0]),
                                (station) => {
                                  return { label: station?.name, value: station?.id };
                                }
                              ),
                            ]
                          : !_.isEmpty(_.get(values, 'city')) &&
                          !_.isEmpty(_.get(values, 'state')) &&
                          values.country &&
                          !_.isEmpty(stationList) && [{ label: 'All', value: 'All' }]
                      }
                      placeholder={t('placeHolder.selectStation')}
                      name="charging_station"
                      isMulti
                      value={values.charging_station}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        if (_.includes(val, 'All')) {
                          setChangeStation(true);
                          setFieldValue(`charging_station`, 'All');
                        } else if (_.isEmpty(val)) {
                          setChangeStation(false);
                          setFieldValue(`charging_station`, '');
                        } else {
                          setChangeStation(false);
                          setFieldValue(`charging_station`, val);
                        }
                        setFieldValue('charger_id', ''); // Reset charger_id when charging_station changes
                      }}
                    />
                    <Select
                      label={t('Charger Id')}
                      options={
                        !_.isEmpty(stationList)
                          ? !changeStation && values.charging_station && values.charging_station !== 'All'
                            ? _.flatMap(
                              stationList.filter(
                                (station) => values.charging_station.includes(station.id)
                              ),
                              (station) =>
                                station.chargers && station.chargers.length > 0
                                  ? station.chargers
                                    .filter((charger) => !charger.is_deleted)
                                    .map((charger) => ({
                                      label: charger.charger_id,
                                      value: charger.id,
                                    }))
                                  : []
                            )
                            : []
                          : !changeStation && values.charging_station && values.charging_station !== 'All'
                            ? _.flatMap(
                              stationList.filter(
                                (station) => values.charging_station.includes(station.id)
                              ),
                              (station) =>
                                station.chargers && station.chargers.length > 0
                                  ? station.chargers
                                    .filter((charger) => !charger.is_deleted)
                                    .map((charger) => ({
                                      label: charger.charger_id,
                                      value: charger.id,
                                    }))
                                  : []
                            )
                            : []
                      }
                      placeholder={t('Charger Id')}
                      name="charger_id"
                      isMulti
                      value={values.charger_id}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        if (_.isEmpty(val)) {
                          setFieldValue(`charger_id`, '');
                          setChangeStation(false);
                        } else {
                          setChangeStation(false);
                          setFieldValue('charger_id', val);
                        }
                      }}
                    />
                    <Select
                      label={t('filters.ocpiBooking')}
                      options={[
                        { label: 'true', value: 'true' },
                        { label: 'false', value: 'false' },
                      ]}
                      placeholder={t('placeHolder.selectAnyone')}
                      name="is_ocpi_based_booking"
                      value={values.is_ocpi_based_booking}
                      onChange={(val) => {
                        setFieldValue('is_ocpi_based_booking', val);
                        setIsOcpiPartyId(val);
                      }}
                    />
                    {isOcpiPartyId == 'true' ? (
                      <Select
                        label={t('filters.ocpiParties')}
                        options={[
                          ..._.map(ocpidata, (data) => {
                            return { label: data.partyId, value: data.partyId };
                          }),
                        ]}
                        placeholder={t('placeHolder.selectAnyone')}
                        name="partyId"
                        onMenuScrollDown={true}
                        getDataOnScrollDown={getOcpidata}
                        page={ocpiPage}
                        totalPage={ocpiTotalPages}
                        value={values.partyId}
                        onChange={(val) => {
                          setFieldValue('partyId', val);
                        }}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="canvas-btn__block">
                  <Button type="submit" className="apply--btn w-100">
                    {t('button.applyFilters')}
                  </Button>
                  <div
                    className="reset--block"
                    onClick={() => {
                      setAdvanceFilterData({});
                      b2cStationChargingHistory();
                      resetForm();
                      onCloseAdvanceFilterPopup();
                    }}
                  >
                    <MdClear size={24} className="reset--icon" />
                    {t('button.clear')}
                  </div>
                </div>
              </Form>
            )}
          </Formik>

        </OffCanvas>
      )}
    </>
  );
};

export default ChragingHistoryReport;
